import React from "react";
//import "./style.scss";

type Props = {
  title: string;
  subtitle: string;
  toggleChat: () => void;
  showCloseButton: boolean;
  titleAvatar?: string;
};

function Header({
  title,
  subtitle,
  toggleChat,
  showCloseButton,
  titleAvatar,
}: Props) {
  return (
    <div className="rcw-header">
      {showCloseButton && (
        <button className="rcw-close-button" onClick={toggleChat}>
          <img src={"https://storage.googleapis.com/seek-logos/ibexco-assests/clear-button.svg"} className="rcw-close" alt="close" />
        </button>
      )}
      <div className="rcw-title">
        {titleAvatar && (
          <img src={titleAvatar} className="avatar" alt="profile" />
        )}
        {title}
      </div>
      {subtitle && <div>{subtitle}</div>}
    </div>
  );
}

export default Header;
